import { graphql, StaticQuery } from "gatsby";
import React from "react";
import { connect } from "react-redux";
import Search from "../Search";
import Categories from "./Categories";
import Copyright from "./Copyright";
import {
  sidebar,
  sidebar__inner,
  sidebar__open__inner
} from "./Sidebar.module.scss";
import Tags from "./Tags";

export const PureSidebar = ({ data, isIndex, isDrawerOpen }) => {
  const { copyright } = data.site.siteMetadata;
  const { tags, categories } = data.allMarkdownRemark;

  return (
    <aside
      className={sidebar}
    >
      <div
        className={`${sidebar__inner} ${
          isDrawerOpen ? sidebar__open__inner : null
        }`}
      >
        <Search />
        <Categories categories={categories} />
        <Tags tags={tags} />
        <Copyright copyright={copyright} />
      </div>
    </aside>
  );
};

export const Sidebar = (props) => (
  <StaticQuery
    query={graphql`
      query SidebarQuery {
        site {
          siteMetadata {
            copyright
          }
        }
        allMarkdownRemark(
          filter: {
            frontmatter: { template: { eq: "post" }, draft: { eq: false } }
          }
        ) {
          tags: group(field: frontmatter___tags) {
            fieldValue
            totalCount
          }
          categories: group(field: frontmatter___category) {
            fieldValue
            totalCount
          }
        }
      }
    `}
    render={(data) => <PureSidebar {...props} data={data} />}
  />
);

export default connect((state) => ({ isDrawerOpen: state.app.isDrawerOpen }))(
  Sidebar
);
